// Actions
export const API_RESPONSE_SUCCESS = 'API_RESPONSE_SUCCESS';
export const API_RESPONSE_ERROR = 'API_RESPONSE_ERROR';
export const GET_OFFICES = 'GET_OFFICES';
export const GET_OFFICES_BY_ID = 'GET_OFFICES_BY_ID';
export const CREATE_OFFICES = 'CREATE_OFFICES';
export const UPDATE_OFFICES = 'UPDATE_OFFICES';
export const DELETE_OFFICES = 'DELETE_OFFICES';
